import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'




import StyledError from '../../../../components/StyledError'
import Toggle from '../../../../components/Toggle/Toggle'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useMutationProps from '../../../../hooks/useMutationProps'
import SetTeamNotificationSettingMutation from '../../../../mutations/SetTeamNotificationSettingMutation'
import {MeetingLabels} from '../../../../types/constEnums'

const EVENTS = [
  'meetingStart',
  'meetingEnd',
  'MEETING_STAGE_TIME_LIMIT_START',
  'MEETING_STAGE_TIME_LIMIT_END'
  //TODO these are not implemented yet:
  //'STANDUP_RESPONSE_SUBMITTED',
  //'TOPIC_SHARED',
] 

const labelLookup = {
  meetingEnd: 'Meeting End',
  meetingStart: 'Meeting Start',
  MEETING_STAGE_TIME_LIMIT_END: `Meeting ${MeetingLabels.TIME_LIMIT} Ended`,
  MEETING_STAGE_TIME_LIMIT_START: `Meeting ${MeetingLabels.TIME_LIMIT} Started`,
  TOPIC_SHARED: `Topic Shared`,
  STANDUP_RESPONSE_SUBMITTED: 'Standup Response Submitted'
} 





const NotificationSettings = (props) => {
  const {settings: settingsRef} = props
  const settings = useFragment(
    graphql`
      fragment NotificationSettings_settings on TeamNotificationSettings {
        id
        events
      }
    `,
    settingsRef
  )
  const {events} = settings

  const atmosphere = useAtmosphere()
  const {submitting, onError, onCompleted, submitMutation, error} = useMutationProps()
  const setNotificationSetting = (event, isEnabled) => {
    if (submitting) {
      return
    }
    submitMutation()
    SetTeamNotificationSettingMutation(
      atmosphere,
      {
        id: settings.id,
        event,
        isEnabled
      },
      {
        onError,
        onCompleted
      }
    )
  }

  return (
    _jsxs('div', { children: [
      error && _jsx(StyledError, { children: error.message})
      , EVENTS.map((event) => {
        const label = labelLookup[event]
        const active = events.includes(event)
        return (
          _jsxs('div', { className: "flex items-center py-2"  , children: [
            _jsx('div', { className: "mr-4 w-full text-sm"  , children: label})
            , _jsx(Toggle, { active: active, onClick: () => setNotificationSetting(event, !active),} )
          ]})
        )
      })
    ]})
  )
}

export default NotificationSettings
